import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { REQUEST_SKU } from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import { BILLING } from 'ui-addon-upgrades/_core/common/constants/AdminTypes';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import UIAdminOnlyWrapper from 'ui-addon-upgrades/decorators/UIAdminOnlyWrapper';
import { getUpgradeDataTrackingProperties } from '../../ums/utils';
import { UPGRADE_POINT_LOCATIONS } from '../common/constants/PurchaseMotionLocations';
import { jsx as _jsx } from "react/jsx-runtime";
function PricingPageInterstitialBuyNowButton({
  'data-selenium-id': dataSeleniumId,
  'data-test-id': dataTestId,
  className,
  style = {},
  seleniumId,
  onClick,
  trackingSource,
  use,
  children,
  upgradeData,
  size,
  location,
  block
}) {
  const isUpgradePoint = location && UPGRADE_POINT_LOCATIONS.includes(location);
  const {
    screen,
    upgradeProduct,
    uniqueId
  } = upgradeData;
  const handleClick = event => {
    tracker.track('interaction', {
      action: 'clicked interstitial redirect',
      screen,
      upgradeProduct,
      uniqueId
    });
    if (isUpgradePoint) {
      tracker.track('interaction', Object.assign({
        action: 'clicked upgrade point'
      }, getUpgradeDataTrackingProperties(upgradeData)));
    }
    if (onClick) {
      onClick(event);
    }
  };
  return /*#__PURE__*/_jsx(UIAdminOnlyWrapper, {
    adminType: BILLING,
    modalType: REQUEST_SKU,
    upgradeData: upgradeData,
    children: /*#__PURE__*/_jsx(UIButton, {
      "data-selenium-id": dataSeleniumId || `${trackingSource}-${seleniumId}-interstitial-buyTouchless-button`,
      "data-test-id": dataTestId || `${trackingSource}-${seleniumId}-interstitial-buyTouchless-button`,
      className: className,
      style: style,
      use: use,
      onClick: handleClick,
      target: "_blank",
      truncate: true,
      size: size,
      block: block,
      children: children || /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'upgrades.checkoutButton.default'
      })
    })
  });
}
export default PricingPageInterstitialBuyNowButton;